import { render } from "./ExportsMain.vue?vue&type=template&id=1ff5093f"
import script from "./ExportsMain.vue?vue&type=script&lang=js"
export * from "./ExportsMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__